var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-autocomplete',{staticStyle:{"width":"360px"},attrs:{"fetch-suggestions":_vm.querySearchAsync,"clearable":"","placeholder":"输入资质关键字，如：工程设计"},on:{"select":_vm.selectQua},model:{value:(_vm.personQualifi),callback:function ($$v) {_vm.personQualifi=$$v},expression:"personQualifi"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }